import { Component,
         OnInit,
         OnDestroy } from '@angular/core'

import { CookieConsent,
         CookieService,
         RouterService } from 'src/app/_core/index'

@Component({
  moduleId: module.id,
  selector: 'ss-cookie-consent-popup',
  templateUrl: 'cookie-consent-popup.component.html',
  styleUrls: ['cookie-consent-popup.component.scss']
})

export class CookieConsentPopupComponent implements OnInit, OnDestroy {

  cookieConsent$: any
  cookieConsent: CookieConsent = new CookieConsent()
  requireCookieConsent$: any
  cookieConsentIsNeeded = false
  isSubmitting = false
  requireCookieConsent = false

  constructor(
    private cookieService: CookieService,
    private routerService: RouterService,
  ) {}

  ngOnInit() {
    this.cookieService.populateCookieConsentFromCookie()
    this.cookieConsent$ = this.cookieConsentStream()
    this.requireCookieConsent$ = this.requireCookieConsentStream()
  }

  ngOnDestroy() {
    if (this.cookieConsent$) this.cookieConsent$.unsubscribe()
    if (this.requireCookieConsent$) this.requireCookieConsent$.unsubscribe()
  }

  cookieConsentStream() {
    return this.cookieService.cookieConsent.subscribe((res: CookieConsent) => {
      this.isSubmitting = false
      if (!res || !res.necessary) return this.cookieConsentIsNeeded = true
      let msSinceUpdate = Date.now() - res.updated_at
      // msIn12Months = 1000 * 60 * 60 * 24 * 365
      // msIn1Minute = 1000 * 60
      let maxTimeDiff = 1000 * 60 * 60 * 24 * 365
      console.log('cookieConsentNeeded', msSinceUpdate > maxTimeDiff, maxTimeDiff, msSinceUpdate)
      this.cookieConsentIsNeeded = msSinceUpdate > maxTimeDiff
    })
  }

  requireCookieConsentStream() {
    return this.cookieService.requireCookieConsent.subscribe((res: boolean) => {
      this.requireCookieConsent = res
    })
  }

  navigateToCookieConsentPage() {
    let outletParams = { primary: 'cookies', secondary: null }
    this.routerService.updateOutlets(outletParams)
  }

  acceptAllCookies() {
    this.isSubmitting = true
    let acceptConsent = new CookieConsent({
      'necessary': true,
      'performance': true,
      'targeting': true,
      'updated_at': Date.now(),
      'ver': 1
    })
    // console.log('acceptCookies', acceptConsent)
    this.cookieService.setCookieConsent(acceptConsent)
  }

  onPopupClose(e: any) {
    this.acceptAllCookies()
  }
}
